import { render } from "./ViewJob.vue?vue&type=template&id=c82cca1c"
import script from "./ViewJob.vue?vue&type=script&lang=js"
export * from "./ViewJob.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__